import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { isEmpty, LoadingDots, PhoneInput } from "../CommonComponents/Common";
import { ReactComponent as DeleteIcon } from "../../../assets/Images/Delete.svg";
import { ReactComponent as InfoIcon } from "../../../assets/icons/info.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/Images/DownloadIcon.svg";
import FileUploadComponent from "./FileUploadComponent";
import AddIcon from "@mui/icons-material/Add";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { useDispatch, useSelector } from "react-redux";
import { checkPromptAction } from "../ProjectSection/CampaignSection/Store/Campaign.action";
import NoticeAlert from "../Common/Alert/NoticeAlert";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";

const TabsSection = ({
  formState,
  setFormState,
  state,
  audienceData,
  setState,
}) => {
  const reducer: any = useSelector((state) => state);
  const dispatch = useDispatch();
  const {
    AgentReducer: { agents },
  } = reducer;
  const [msg, setMsg] = useState("");
  const [downloadexcelSpin, setdownloadexcelSpin] = useState(false);

  let inde = 0;

  function onInputChange(e, index) {
    const audienceList1 = [...audienceData];
    audienceList1[index][e.target.name] = e.target.value;
    setFormState({ ...formState, audienceData: audienceList1 });
  }

  const handlePhoneChange = (e, index) => {
    const phoneNumber = e.trim().replace(/\D/g, "");

    const audienceList1 = [...audienceData];
    audienceList1[index]["phone"] = e;
    setFormState({
      ...formState,
      audienceData: audienceList1,
    });

    if (phoneNumber.length < 7) {
      setMsg("Please enter valid number.");
      return;
    }

    if (phoneNumber.length > 20) {
      setMsg("Phone number cannot be more than 20 numbers.");
      return;
    }

    const isDuplicate = audienceData?.some(
      (aud, i) => aud?.phone === phoneNumber && i !== index
    );
    if (isDuplicate) {
      setMsg("Duplicated Number Found.");
      setState((prev) => ({
        ...prev,
        buttonDisable: true,
      }));
      return;
    }

    setMsg("");
    setState((prev) => ({
      ...prev,
      buttonDisable: false,
    }));
  };

  function addAudienceForm() {
    if (formState.audienceData[inde].phone.length < 6) {
      setMsg(`Enter valid number`);
      setTimeout(() => {
        setMsg("");
      }, 5000);
    } else {
      setFormState({
        ...formState,
        audienceData: [
          ...formState.audienceData,
          { firstName: "", lastName: "", phone: "" },
        ],
      });
    }
  }

  function removeAudienceForm(index) {
    const audienceList1 = [...audienceData];
    if (audienceList1.length > 1) {
      audienceList1.splice(index, 1);
      setFormState({ ...formState, audienceData: audienceList1 });
      setState((prev) => ({
        ...prev,
        buttonDisable: false,
      }));
      setMsg("");
    }
  }

  const downloadSampleExcel = async () => {
    let final: any = [];
    setdownloadexcelSpin(true);

    let defaultAgent = agents?.find((agen) => agen.default);
    if (!defaultAgent) {
      let obj1 = {
        FirstName: "",
        LastName: "",
        PhoneNum: "",
      };
      final.push(obj1);
    } else {
      let obj = {
        examples: defaultAgent?.conversationData,
        agent_name: defaultAgent?.agentName,
        organization_name: defaultAgent?.organisationName,
        greeting_message: defaultAgent.greetingMessage,
        context: defaultAgent?.context,
        rules: defaultAgent?.rules,
        voice_mail_message: defaultAgent?.voicemailMessage,
      };
      let fields = {};
      let manualKeys: any = await dispatch(checkPromptAction(obj));
      if (manualKeys) {
        manualKeys?.fields.map((keys) => {
          fields[keys] = "";
        });
      }
      let obj1 = {
        FirstName: "",
        LastName: "",
        PhoneNum: "",
        ...fields,
      };
      final.push(obj1);
    }
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(final);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `Campaign List file` + fileExtension);
    setdownloadexcelSpin(false);
  };
  return (
    <Box
      sx={[
        {
          maxHeight: "450px",
        },
        commonStyles.hideScroll,
      ]}
    >
      <Box className="flex-between-only">
        <Box>
          <Tabs
            value={formState?.source.value}
            onChange={(_, newValue) => {
              if (isEmpty(state?.editedAudience)) {
                setFormState({
                  ...formState,
                  source: { value: newValue },
                });
              }
            }}
            sx={commonStyles.tabs}
          >
            <Tab label="Upload file" value="excel" sx={commonStyles.tab} />
            <Tab label="Create Manually" value="manual" sx={commonStyles.tab} />
          </Tabs>
        </Box>
        <IconButton
          sx={{
            padding: 0,
            gap: 1,
            color: "#4280FF",
            textTransform: "capitalize",
          }}
          disableRipple
          disableFocusRipple
          style={{ outline: "none" }}
          onClick={() => downloadSampleExcel()}
        >
          <DownloadIcon className="download-icon" />
          <Box
            component="span"
            sx={{
              fontSize: 14,
              fontWeight: 400,
              color: "inherit",
              minWidth: 180,
            }}
          >
            {downloadexcelSpin ? <LoadingDots /> : "Download Sample Excel file"}
          </Box>
        </IconButton>
      </Box>
      {formState?.source.value === "manual" && (
        <Box
          className="flex-column"
          sx={{
            gap: 2,
            mt: 2,
          }}
        >
          {audienceData.map((audience, index) => {
            inde = index;
            return (
              <Box
                key={index}
                className="flex-xy-center"
                sx={{
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                  }}
                >
                  <Typography className="font-14-grey mb-1">
                    First Name
                  </Typography>
                  <TextField
                    name="firstName"
                    value={audience.firstName}
                    onChange={(e) => onInputChange(e, index)}
                    variant="outlined"
                    fullWidth
                    placeholder="Enter first name eg: “Olivia”"
                    sx={commonStyles.inputField}
                  />
                </Box>
                <Box
                  sx={{
                    flex: 1,
                  }}
                >
                  <Typography className="font-14-grey mb-1">
                    Last Name
                  </Typography>
                  <TextField
                    name="lastName"
                    value={audience.lastName}
                    onChange={(e) => onInputChange(e, index)}
                    variant="outlined"
                    fullWidth
                    placeholder="Enter last name eg: “Angel”"
                    sx={commonStyles.inputField}
                  />
                </Box>
                <Box
                  sx={{
                    flex: 1,
                  }}
                >
                  <Typography className="font-14-grey mb-1">
                    Phone Number
                  </Typography>
                  <Box sx={{ position: "relative" }}>
                    <PhoneInput
                      specialLabel={""}
                      country={"us"}
                      value={audience.phone}
                      enableLongNumbers={true}
                      onChange={(e) => handlePhoneChange(e, index)}
                      buttonStyle={commonStyles.phoneInput.buttonStyle}
                      inputStyle={commonStyles.phoneInput.inputStyle}
                      containerStyle={commonStyles.phoneInput.containerStyle}
                      inputProps={{
                        placeholder: "Enter the phone number",
                      }}
                    />
                  </Box>
                </Box>
                <Box className="flex-xy-center">
                  <IconButton onClick={() => removeAudienceForm(index)}>
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </Box>
            );
          })}

          {msg && (
            <span className="m-1" style={{ color: "red", fontSize: "13px" }}>
              {msg}
              <br />
              <br />
            </span>
          )}
          <Box
            sx={{
              justifyItems: "flex-start",
            }}
          >
            <Button
              onClick={() => addAudienceForm()}
              variant="outlined"
              startIcon={
                <AddIcon
                  style={{
                    color: "#666666",
                    padding: 1,
                    backgroundColor: "white",
                  }}
                />
              }
              sx={commonStyles.addBtn}
            >
              Add
            </Button>
          </Box>
        </Box>
      )}

      {formState?.source.value === "excel" && (
        <Box>
          <NoticeAlert
            title="Check your file before upload"
            content="It's essential to ensure that the file you're working with is
                valid. After making any adjustments, it's recommended to
                re-verify the data against the existing information to maintain
                accuracy and completeness. Thank you for your attention to these
                details."
          />

          <Box
            className="flex-align-center"
            sx={{
              gap: 1,
              my: 1,
            }}
          >
            <Box component="span" className="font-14-grey">
              Upload Documents
            </Box>
            <InfoIcon />
            <Box component="span" className="font-13-400-lightgrey-1">
              only .xlsx, .xls files are accepted
            </Box>
          </Box>
          <FileUploadComponent setState={setState} />
        </Box>
      )}
    </Box>
  );
};

export default TabsSection;
